import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1300px;
  display: flex;
  flex-direction: column;

  h1,
  h2 {
    text-align: left;
    margin-bottom: 15px;
    color: #000;
  }

  @media (max-width: 750px) {
    padding: 10px 0;
    h1,
    h2 {
      font-size: 22px;
    }
  }
`;
